import React from "react";
import { Api } from "../../utils/api";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Collapse from "@material-ui/core/Collapse";
import { withRouter } from "react-router";
import classNames from "classnames";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import moment from "moment";
import Divider from "@material-ui/core/Divider";
import { Field, Form, Formik } from "formik";
import {
  DatePicker,
  DateTimePicker,
} from "../components/datetime-picker.component";
import ReactDatePicker from "../../components/reactdatepicker.component";
import { TextField } from "formik-material-ui";
import { EstablishmentPlanBadge } from "./establishment_plan_badge.component";
import Button from "@material-ui/core/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Dialog from "@material-ui/core/Dialog/Dialog";
import { AdminView } from "./admin_view.component";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import AlertDialog from "./alert-establishment-groups.component";
import { MaterialSelectFormik } from "../components/select-field.component";
import RequestModeBadge from "./request_mode_badge.component";

export const styles = (theme) => {
  const transition = {
    duration: theme.transitions.duration.shortest,
  };
  return {
    expanded: {},
    /* Styles applied to the root and children wrapper elements when focused. */
    expandIcon: {
      padding: "21px",
      transform: "rotate(0deg)",
      transition: theme.transitions.create("transform", transition),
      "&:hover": {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: "transparent",
      },
      "&$expanded": {
        transform: "rotate(180deg)",
      },
    },
  };
};

class ExpandIconBase extends React.Component {
  render() {
    const { disabled, expanded, classes, onClick } = this.props;
    return (
      <IconButton
        disabled={disabled}
        className={classNames(classes.expandIcon, {
          [classes.expanded]: expanded,
        })}
        component="div"
        tabIndex={-1}
        aria-hidden="true"
        onClick={onClick}
      >
        <ExpandMoreIcon />
      </IconButton>
    );
  }
}

const ExpandIcon = withStyles(styles, { withTheme: true })(ExpandIconBase);

export class EstablishmentRequestMessages extends React.Component {
  state = {
    messages: null,
  };

  constructor() {
    super();
    this.api = new Api();
  }

  componentDidMount() {
    this.api
      .get(
        `/establishment_requests/${this.props.establishmentRequestId}/messages`
      )
      .then(({ data: messages }) => {
        return this.setState({ messages });
      })
      .catch(() => console.log("erro a sacar sms"));
  }

  createMarkup = (html) => {
    return { __html: html };
  };

  render() {
    const { messages } = this.state;
    if (messages) {
      const {
        first_client_sms,
        second_client_sms,
        first_requester_sms,
        second_requester_sms,
      } = messages;
      return (
        <>
          <Paper className="sms-client" square>
            <div
              dangerouslySetInnerHTML={this.createMarkup(first_client_sms)}
            />
          </Paper>
          <Paper className="sms-client" square>
            <div
              dangerouslySetInnerHTML={this.createMarkup(second_client_sms)}
            />
          </Paper>
          <Paper className="sms-requester" square>
            <div
              dangerouslySetInnerHTML={this.createMarkup(first_requester_sms)}
            />
          </Paper>
          <Paper className="sms-requester" square>
            <div
              dangerouslySetInnerHTML={this.createMarkup(second_requester_sms)}
            />
          </Paper>
        </>
      );
    } else {
      return "";
    }
  }
}

class EstablishmentRequestCard extends React.Component {
  state = {
    group: null,
    establishmentGroup: null,
    establishmentRequest: null,
    steps: [],
    expanded: false,
    message: "Loading...",
    open: false,
    showAlert: false,
    alertTitle: "",
    alertMessage: "",
    visitDate: "",
    visit_info: [],
    visit_days_unavailable: [],
    next_visit: null,
  };

  generateSteps(establishmentRequest) {
    const maybeFormat = (date, format = "YYYY-MM-DD") => {
      return date ? moment(date).format(format) : date;
    };
    const maybeFormatTime = (date, format = "YYYY-MM-DD [] HH:mm") => {
      if (!date) return date;
      const newDate = moment(date);
      return (
        <>
          {newDate.format("YYYY-MM-DD")}
          <br />
          {newDate.format("HH:mm")}
        </>
      );
    };

    const { sent_at, request_accepted, request_admitted, easypay_payments } =
      establishmentRequest;
    return [
      {
        name: "encaminhado",
        data: maybeFormatTime(sent_at),
      },
      {
        name: "aceite",
        data: maybeFormatTime(request_accepted),
      },
      {
        name: "contactado",
        data: establishmentRequest.contacted,
        optional: true,
      },
      {
        name: "visitado",
        data: establishmentRequest.visited,
      },
      {
        name: "pré-confirmado",
        data: maybeFormatTime(establishmentRequest.request_preadmitted),
      },
      {
        name: "admitido",
        data: maybeFormat(request_admitted),
      },
      {
        name: "faturado",
        data: easypay_payments ? maybeFormat(easypay_payments[0].ep_date) : "",
        /*color: easypay_payments? 
        easypay_payments[0].easypay_payment_invoice[0].status === "settled" ? 
          "green" : 
          "black" 
        : "black"
      */
      },
    ];
  }

  handleStep(index) {
    const {
      sent_at,
      request_accepted,
      visited,
      contacted,
      request_preadmitted,
      request_admitted,
      id,
    } = this.state.establishmentRequest;
    switch (index) {
      case 0:
      case 1:
        return;
      case 2:
        if (!sent_at || !request_accepted) return;
        this.updateRequest({ contacted: !contacted });
        return;
      case 3:
        if (!sent_at || !request_accepted) return;
        this.updateRequest({ visited: !visited });
        return;
      case 4:
        if (!sent_at || !request_accepted) return;
        if (request_preadmitted) {
          return this.updateRequest({
            request_preadmitted: request_preadmitted,
          });
        }
        if (request_admitted) {
          return;
        }
      case 5:
        if (!sent_at || !request_accepted) return;
        if (request_admitted) {
          this.goTo(`/requests_history/${id}`);
        }
        return;

        this.setState({ open: true });
        return;
    }
  }

  updateRequest(data) {
    const { id } = this.state.establishmentRequest;
    const user_id = localStorage.getItem("id");
    if (data.request_admitted) data.admitted_by = user_id;
    return this.api
      .patch(`/establishment_requests/${id}`, data)
      .then(({ data: er }) => {
        this.updateLocalRequest({ data: er });
        if (er.payment)
          this.createNewInvoice({ data: er }).then(
            this.getEstablishmentsRequests()
          );
      });
  }

  updateLocalRequest({ data: er }) {
    const establishmentRequest = er.establishment_request;
    const steps = this.generateSteps(establishmentRequest);
    return this.setState({ establishmentRequest, steps });
  }

  getActiveStep() {
    let i = 0;
    let step = 0;
    for (; i < this.state.steps.length; i++) {
      if (this.state.steps[i].data) {
        step = i;
      }
    }
    return step;
  }

  //create new invoice
  createNewInvoice({ data: er }) {
    const establishmentRequest = er.establishment_request;
    const payment = er.payment;
    const due_date_str = moment(moment.now())
      .add(30, "days")
      .format("YYYY-MM-DD");
    return this.api.post(`invoicexpress_invoices/`, {
      invoice_type: "invoice",
      invoice_date: moment(moment.now()).format("YYYY-MM-DD"),
      invoice_due_date: moment(moment.now()).format("YYYY-MM-DD"),
      observations:
        "Os artigos/serviços constantes no presente documento, foram colocados à disposição do adquirente a " +
        moment(establishmentRequest.request_admitted).format("YYYY-MM-DD") +
        " (alínea f do nº5 do Artº36 CIVA).\nCobrança por Débito em Conta a partir do dia " +
        due_date_str,
      entity_id:
        establishmentRequest.establishment_valence.establishment.entity_id,
      payment_items: [
        {
          description: payment.description,
          observations: payment.observations,
          ep_value: payment.ep_value,
        },
      ],
      payment_type:
        payment.payment_method && payment.payment_method === "MB"
          ? "payment_type_mb"
          : "payment_type_dd",
      payment_id: payment.ep_key,
      send_email: true,
      close_invoice: false,
      payment_at: due_date_str,
    });
  }

  constructor() {
    super();
    this.steps = [];
    this.api = new Api();
    this.handleStep = this.handleStep.bind(this);
    this.updateRequest = this.updateRequest.bind(this);
    this.updateLocalRequest = this.updateLocalRequest.bind(this);
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.goTo = this.goTo.bind(this);
    this.getEstablishmentGroup = this.getEstablishmentGroup.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.endMotivesPromise = this.endMotivesPromise.bind(this);
    this.endMotivesToSelect = this.endMotivesToSelect.bind(this);
    this.handleChangeVisitTime = this.handleChangeVisitTime.bind(this);
    this.getVisitDatesFromEachEstablishment =
      this.getVisitDatesFromEachEstablishment.bind(this);
    this.getEstablishmentsRequests = this.getEstablishmentsRequests.bind(this);
  }

  handleClose() {
    this.setState({ open: false });
  }

  componentDidMount() {
    this.getEstablishmentsRequests();
    this.getVisitDatesFromEachEstablishment();
  }

  getEstablishmentsRequests() {
    const { id } = this.props;
    if (!id) return;
    this.api
      .get(`/establishment_requests/${id}`)
      .then(({ data: establishmentRequest }) => {
        if (establishmentRequest.visit_time !== null) {
          //correçao de horas por causa da API adicionar subtrair 1h no insert e adicionar 1h no get
          let visit_time = new Date(establishmentRequest.visit_time);
          let visit_time_local = visit_time.setHours(visit_time.getHours() - 1);
          this.setState({ visitDate: visit_time_local });
        }
        const steps = this.generateSteps(establishmentRequest);
        this.setState({ establishmentRequest, steps });
      })
      .catch(() => {
        this.setState({ message: "Error Loading Establishment Request" });
      });
  }

  getVisitDatesFromEachEstablishment() {
    this.api
      .get(`establishment_valences`, { estValence: this.props.estValence })
      .then(({ data = null }) => {
        //informaçao das visitas
        this.setState({ visit_info: data.visits });

        //proxima visita
        let next_visit = data.next_visit
          ? moment(data.next_visit.visit_time).subtract(1, "hour")
          : null;
        this.setState({ next_visit: next_visit });

        //verifica datas indisponiveis para cada equipamento e coloca-as num array
        let array_of_dates = [];
        this.state.visit_info.map((d) =>
          array_of_dates.push(moment(d.visit_time).subtract(1, "hour"))
        );
        this.setState({ visit_days_unavailable: array_of_dates });
        console.log(this.state.next_visit);
      });
  }

  toggleExpanded() {
    this.setState({ expanded: !this.state.expanded });
  }

  goTo(location, params) {
    this.props.history.push(location, params);
  }

  remove = () => {
    const { id } = this.props;
    if (!id) return;

    this.api
      .delete(`/establishment_requests/${id}`)
      .then(() => {
        this.props.onRemove();
      })
      .catch(() => {
        this.setState({ message: "Error Removing Establishment" });
      });
  };

  showAlert(title, message) {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: title });
    this.setState({ alertMessage: message });
  }

  closeAlert() {
    this.setState({ showAlert: false });
  }

  async getEstablishmentGroup(groupid) {
    console.log(groupid);

    await this.api
      .get(`/entity_groups`, { id: groupid })
      .then(({ data = null }) => {
        this.setState({ group: data });
      });

    this.api
      .get(`/establishments`, { group: groupid })
      .then(({ data = null }) => {
        this.setState({ establishmentGroup: data.establishments });
        let establishmentGroup = this.state.establishmentGroup
          ? this.state.establishmentGroup
          : 0;
        let text = "";
        for (let i = 0; i < establishmentGroup.length; i++) {
          text +=
            i +
            1 +
            ") " +
            JSON.stringify(establishmentGroup[i].name).replaceAll('"', "") +
            "\r\n";
        }
        this.showAlert(this.state.group[0].name, text);
      });
  }

  // Motivos de saída do lar
  endMotivesToSelect = (options) => {
    return options.map((option) => ({
      value: option.id,
      label: option.motive,
    }));
  };
  endMotivesPromise = () => {
    const api = new Api();
    return api
      .get("/end_of_stay_motives")
      .then((res) => res.data)
      .then(this.endMotivesToSelect);
  };

  /////////////////////////   INPUT VISIT TIME /////////////////////////////////////

  handleChangeVisitTime = (date) => {
    this.setState({ visitDate: date });
    this.checkAvailabilityVisitTime(date);
    //console.log(moment(date).format("YYYY-MM-DD HH:mm"));
  };

  //Tooltip de acordo com disponibilidade
  checkAvailabilityVisitTime = (date) => {
    if (
      this.state.visit_info.find(
        (d) =>
          moment(d.visit_time).subtract(1, "hour").format("YYY-MM-DD") ===
          moment(date).format("YYY-MM-DD")
      )
    ) {
      let user_who_booked = this.state.visit_info.find(
        (d) =>
          moment(d.visit_time).subtract(1, "hour").format("YYY-MM-DD") ===
          moment(date).format("YYY-MM-DD")
      ).name;
      let user_request_id = this.state.visit_info.find(
        (d) =>
          moment(d.visit_time).subtract(1, "hour").format("YYY-MM-DD") ===
          moment(date).format("YYY-MM-DD")
      ).user_request_id;
      let url_request = "/user_requests/" + user_request_id;
      const tooltip = this.showAlert(
        "Data indisponível",
        <div>
          {" "}
          Visita marcada por {user_who_booked} <br />{" "}
          <center className="mt-2">
            <a href={url_request} target="_blank">
              Ver pedido
            </a>
          </center>{" "}
        </div>
      );
      this.setState({ visitDate: null });
      return tooltip;
    } else {
      const tooltip = "";
      return tooltip;
    }
  };

  render() {
    const { establishmentRequest } = this.state;
    const { disperseRequest, userRequest } = this.props;

    if (!establishmentRequest) {
      return <div>{this.state.message}</div>;
    }

    const { establishment_valence: establishmentValence } =
      establishmentRequest;
    const { establishment } = establishmentValence;
    const { name } = establishmentValence.establishment;
    const gps_dist = establishmentRequest.gps_dist;
    const group_id_from_entity = establishmentRequest.entity_group_id;

    let end_of_stay =
      establishmentRequest.end_of_stay_date !== null
        ? moment(establishmentRequest.end_of_stay_date)
        : moment().startOf("day");
    let admission = moment(establishmentRequest.request_admitted);
    let time_of_stay_in_days = end_of_stay.diff(admission, "days");

    return (
      <div>
        <Tooltip
          title={
            establishmentRequest.disabled_requests
              ? "Sem acesso a pedidos"
              : establishmentRequest.force_requests
              ? "Com potencial de angariação"
              : ""
          }
        >
          <Paper
            elevation={1}
            square
            className={
              "distance-from-top" +
              (establishmentRequest.force_requests ? " force-requests" : "") +
              (establishmentRequest.disabled_requests
                ? " disable-requests"
                : "") +
              (establishmentRequest.request_admitted
                ? " green-background"
                : "") +
              (establishmentRequest.request_canceled ? " canceled" : "")
            }
          >
            <Grid container>
              <Grid item md={5}>
                <Grid container className="height-100">
                  <Grid container className="align-content-space-around">
                    <Grid container>
                      <Typography gutterBottom variant="subtitle2">
                        {name}
                      </Typography>
                      {gps_dist && (
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#4682b4",
                            marginLeft: "7px",
                          }}
                        >
                          {" "}
                          ({gps_dist.toFixed(2)} Kms){" "}
                        </span>
                      )}
                    </Grid>
                    <Grid container alignItems="center" justify="space-between">
                      <Grid item md={4}>
                        <EstablishmentPlanBadge
                          plan={establishmentRequest.plan}
                        />
                      </Grid>
                      {!establishmentRequest.in_social_charter && (
                        <Grid item md={2}>
                          <Tooltip title="Carta Social">
                            <Typography
                              style={{ textAlign: "center" }}
                              gutterBottom
                              variant="subtitle2"
                            >
                              CS
                            </Typography>
                          </Tooltip>
                        </Grid>
                      )}
                      <Grid item md={2}>
                        {group_id_from_entity !== undefined && (
                          <button
                            type="button"
                            class={
                              group_id_from_entity === null
                                ? "d-none"
                                : "btn-ent-group-G"
                            }
                            value={group_id_from_entity}
                            onClick={() => {
                              this.getEstablishmentGroup(group_id_from_entity);
                            }}
                            id="btn-establishment-group"
                          >
                            <Tooltip title="Clique para visualizar o grupo">
                              <Typography
                                style={{
                                  textAlign: "center",
                                  fontSize: "0.875rem",
                                }}
                                gutterBottom
                                variant="subtitle2"
                                class="text-black"
                              >
                                G
                              </Typography>
                            </Tooltip>
                          </button>
                        )}
                        <AlertDialog
                          open={this.state.showAlert}
                          handleClose={this.closeAlert}
                          title={this.state.alertTitle}
                          message={this.state.alertMessage}
                        ></AlertDialog>
                      </Grid>

                      {establishmentRequest && (
                        <Grid item sm={1}>
                          <RequestModeBadge
                            mode={establishmentRequest.request_mode}
                          />
                        </Grid>
                      )}

                      {!establishmentRequest.auto_selected && (
                        <Grid item md={2}>
                          <Tooltip title="Encaminhamento Manual">
                            <Typography
                              style={{ textAlign: "center" }}
                              gutterBottom
                              variant="subtitle2"
                            >
                              M
                            </Typography>
                          </Tooltip>
                        </Grid>
                      )}

                      {/* MENSALIDADES */}
                      <Grid item md={2}>
                        <Tooltip title="Mensalidade Mínima do Equipamento">
                          <Typography gutterBottom variant="body2">
                            <FontAwesomeIcon icon="euro-sign" />
                            {establishmentValence.min_price}
                            {establishmentValence.jewelry_type === "none" ? (
                              <Typography variant="caption">
                                sem jóia ou caução
                              </Typography>
                            ) : (
                              establishmentValence.jewelry_type &&
                              establishmentValence.jewelry_value && (
                                <Typography variant="caption">
                                  {establishmentValence.jewelry_type}:{" "}
                                  {establishmentValence.jewelry_value}
                                </Typography>
                              )
                            )}
                          </Typography>
                        </Tooltip>
                        {establishmentRequest.request_admitted && (
                          <Tooltip title="Mensalidade Acordada">
                            <Typography variant="body2">
                              <p>
                                <FontAwesomeIcon icon="euro-sign" />
                                <b>{establishmentRequest.monthly_payment}</b>
                              </p>
                            </Typography>
                          </Tooltip>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container alignItems="center">
                      <Grid item md={3}>
                        <Typography gutterBottom variant="caption">
                          {establishment.district.name} -{" "}
                          {establishment.county.name}
                        </Typography>
                      </Grid>
                      <Grid item md={3}>
                        <AdminView
                          adminId={establishment.county.county_manager_id}
                          label="GZ"
                          image={true}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4}>
                {establishmentRequest.sent_at && !disperseRequest && (
                  <Stepper
                    className={
                      (establishmentRequest.disabled_requests
                        ? " disable-requests"
                        : "") +
                      (establishmentRequest.force_requests
                        ? " force-requests"
                        : "") +
                      (establishmentRequest.request_admitted
                        ? " green-background"
                        : "") +
                      (establishmentRequest.request_canceled ? " canceled" : "")
                    }
                    alternativeLabel
                    nonLinear
                    activeStep={this.getActiveStep()}
                  >
                    {this.state.steps.map((step, index) => {
                      const props = {};
                      const buttonProps = {};
                      if (step.optional && !step.data) {
                        buttonProps.optional = (
                          <Typography variant="caption">Opcional</Typography>
                        );
                      }
                      if (step.data) {
                        props.completed = true;
                        buttonProps.optional = (
                          <Typography
                            variant="caption"
                            style={{ color: step.color ? step.color : "black" }}
                          >
                            {step.data}
                          </Typography>
                        );
                      }
                      if (index < this.getActiveStep()) {
                        props.completed = true;
                      }
                      return (
                        <Step
                          key={step.name}
                          {...props}
                          disabled={this.props.isCanceled}
                        >
                          <StepButton
                            onClick={() => this.handleStep(index)}
                            {...buttonProps}
                          >
                            {step.name}
                          </StepButton>
                        </Step>
                      );
                    })}
                  </Stepper>
                )}
                {establishmentRequest.sent_at && disperseRequest && (
                  <Grid
                    container
                    justify="center"
                    alignItems="center"
                    className="sent-email"
                  >
                    <Tooltip title="Email Enviado">
                      <span>
                        <FontAwesomeIcon icon="check-circle" size="md" />
                      </span>
                    </Tooltip>
                  </Grid>
                )}
              </Grid>

              <Grid item md={2}>
                {!establishmentRequest.sent_at &&
                  !disperseRequest &&
                  (!establishmentRequest.auto_selected ||
                    (establishmentRequest.auto_selected &&
                      userRequest.establishment_valence_id !== null &&
                      establishmentValence.valence_id !== 2) ||
                    (establishmentRequest.auto_selected &&
                      establishmentRequest.plan === "Base" &&
                      establishmentRequest.force_requests === 0) ||
                    userRequest.sent_at === null ||
                    (establishmentRequest.auto_selected &&
                      userRequest.establishment_valence_id !== null &&
                      this.props.maxRound === 1)) && (
                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      className="height-100"
                    >
                      <Button
                        size="small"
                        color="secondary"
                        onClick={this.remove}
                      >
                        Remover Equipamento
                      </Button>
                    </Grid>
                  )}
              </Grid>

              <Grid item md={1}>
                <Grid
                  container
                  alignItems="center"
                  className="height-100"
                  justify="flex-end"
                >
                  <ExpandIcon
                    expanded={this.state.expanded}
                    onClick={this.toggleExpanded}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Proxima Visita Agendada */}
            {this.state.next_visit !== null && (
              <Grid item md={12}>
                <div className="next_visit_css">
                  <span className="font-weight-bold">Próxima visita: </span>
                  <span>
                    {moment(this.state.next_visit).format("YYYY-MM-DD HH:mm")}
                  </span>
                </div>
              </Grid>
            )}

            <Collapse
              {...{ in: this.state.expanded }}
              timeout="auto"
              unmountOnExit
            >
              <Divider />
              {userRequest && (
                <Formik
                  initialValues={{
                    ...this.state.establishmentRequest,
                    message_professional:
                      this.state.establishmentRequest.message_professional ===
                      null
                        ? userRequest.message_from_stats
                        : this.state.establishmentRequest.message_professional,
                  }}
                  validateOnChange={false}
                  validateOnBlur={false}
                  onSubmit={(values, { setSubmitting }) => {
                    values.visit_time = moment(this.state.visitDate).add(
                      1,
                      "hour"
                    );
                    return this.updateRequest(values).then(() =>
                      setSubmitting(false)
                    );
                  }}
                  render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    setFieldTouched,
                  }) => {
                    return (
                      <Grid item md={12}>
                        <Form onSubmit={handleSubmit}>
                          <Grid
                            container
                            spacing={8}
                            style={{ padding: "24px" }}
                          >
                            {!disperseRequest && (
                              <Grid item md={12}>
                                <Field
                                  name="message"
                                  label="Mensagem"
                                  variant="outlined"
                                  margin="normal"
                                  type="text"
                                  component={TextField}
                                  multiline
                                  fullWidth
                                />
                              </Grid>
                            )}
                            <Grid item md={12}>
                              <Field
                                name="message_professional"
                                label="Mensagem Area Profissional"
                                variant="outlined"
                                margin="normal"
                                type="text"
                                component={TextField}
                                multiline
                                fullWidth
                                disabled
                              />
                            </Grid>
                            <Grid item md={3}>
                              <Field
                                name="sent_at"
                                label="Encaminhado a"
                                variant="outlined"
                                margin="normal"
                                disabled
                                format="DD/MM/YYYY HH:mm"
                                component={DateTimePicker}
                                fullWidth
                              />
                            </Grid>
                            <Grid item md={3}>
                              <Field
                                name="request_accepted"
                                label="Aceite a"
                                variant="outlined"
                                margin="normal"
                                onChange={setFieldValue}
                                component={DateTimePicker}
                                fullWidth
                              />
                            </Grid>

                            <Grid item md={3}>
                              <Field
                                name="request_canceled"
                                label="Cancelado a"
                                variant="outlined"
                                margin="normal"
                                onChange={setFieldValue}
                                component={DatePicker}
                                fullWidth
                              />
                            </Grid>

                            <Grid
                              item
                              md={3}
                              className="mt-4 position-relative"
                            >
                              <label>
                                <div className="visit-calendar-label">
                                  Data de visita
                                </div>
                                <ReactDatePicker
                                  handleChangeVisitTime={
                                    this.handleChangeVisitTime
                                  }
                                  visitDate={this.state.visitDate}
                                  visit_days_unavailable={
                                    this.state.visit_days_unavailable
                                  }
                                />
                              </label>
                            </Grid>

                            <Grid item md={3}>
                              <Field
                                name="request_preadmitted"
                                label="Pré-confirmação"
                                variant="outlined"
                                margin="normal"
                                onChange={setFieldValue}
                                component={DateTimePicker}
                                fullWidth
                              />
                            </Grid>

                            <Grid item md={3}>
                              <Field
                                label="Data de Admissão"
                                name="admission_date"
                                variant="outlined"
                                margin="normal"
                                onChange={setFieldValue}
                                component={DatePicker}
                                fullWidth
                              />
                            </Grid>
                            <Grid item md={3}>
                              <Field
                                name="request_admitted"
                                label="Admitido a"
                                variant="outlined"
                                margin="normal"
                                onChange={setFieldValue}
                                component={DatePicker}
                                fullWidth
                              />
                            </Grid>

                            <Grid item md={3} />

                            <Grid item md={3}>
                              <Field
                                style={{ borderColor: "coral" }}
                                name="monthly_payment"
                                label="Mensalidade"
                                variant="outlined"
                                margin="normal"
                                type="number"
                                onChange={setFieldValue}
                                component={TextField}
                                fullWidth
                                className="mensalidade-acordada"
                              />
                            </Grid>

                            <Grid item md={3}>
                              <Field
                                name="jewelry_value"
                                label="Valor da Jóia"
                                variant="outlined"
                                margin="normal"
                                type="number"
                                disabled={
                                  values.deposit_value === "" ||
                                  values.deposit_value === null
                                    ? false
                                    : true
                                }
                                component={TextField}
                                fullWidth
                              />
                            </Grid>
                            <Grid item md={3}>
                              <Field
                                name="deposit_value"
                                label="Valor da Caução"
                                variant="outlined"
                                margin="normal"
                                type="number"
                                disabled={
                                  values.jewelry_value === "" ||
                                  values.jewelry_value === null
                                    ? false
                                    : true
                                }
                                component={TextField}
                                fullWidth
                              />
                            </Grid>

                            <Grid item md={3} />

                            <Grid item md={3}>
                              <Field
                                name="end_of_stay_date"
                                label="Data de saída"
                                variant="outlined"
                                margin="normal"
                                onChange={setFieldValue}
                                component={DatePicker}
                                fullWidth
                              />
                            </Grid>

                            <Grid item md={3} className="mt-4 pt-4">
                              <MaterialSelectFormik
                                name="end_of_stay_motive"
                                placeholder="Motivo de saída"
                                label="Motivo de saída"
                                onChange={setFieldValue}
                                onBlur={setFieldTouched}
                                value={values.end_of_stay_motive}
                                optionsFetcher={this.endMotivesPromise}
                              />
                            </Grid>
                            <Grid item md={3}>
                              {establishmentRequest &&
                                establishmentRequest.request_admitted !=
                                  null && (
                                  <p class="mt-4 pt-2 text-secondary">
                                    Tempo de estadia: {time_of_stay_in_days}{" "}
                                    {time_of_stay_in_days === 1
                                      ? "dia"
                                      : "dias"}
                                  </p>
                                )}
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container className="expansion">
                            <Button
                              size="small"
                              color="primary"
                              type="submit"
                              disabled={isSubmitting}
                            >
                              Save
                            </Button>
                          </Grid>
                        </Form>
                      </Grid>
                    );
                  }}
                />
              )}
              <Divider />
              <EstablishmentRequestMessages
                establishmentRequestId={this.props.id}
              />
            </Collapse>
          </Paper>
        </Tooltip>
        <Formik
          initialValues={{
            request_admitted: establishmentRequest.request_admitted || "",
          }}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={(values, { setSubmitting }) => {
            return this.updateRequest(values).then(() => {
              setSubmitting(false);
              this.handleClose();
            });
          }}
          render={({
            values,
            errors,
            status,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => {
            return (
              <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title"
                className="overflow-y-visible"
                PaperProps={{
                  className: "overflow-y-visible",
                }}
              >
                <Form>
                  <DialogTitle id="form-dialog-title">
                    Data de Admissão
                  </DialogTitle>
                  <DialogContent className="overflow-y-visible">
                    <DialogContentText>
                      Por favor, seleccione a data de admissão
                    </DialogContentText>
                    <br></br>
                    <Field
                      name="request_admitted"
                      label="Data de admissão"
                      variant="outlined"
                      margin="normal"
                      onChange={setFieldValue}
                      component={DateTimePicker}
                      fullWidth
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                      Fechar
                    </Button>
                    <Button size="small" color="primary" type="submit">
                      Save
                    </Button>
                  </DialogActions>
                </Form>
              </Dialog>
            );
          }}
        />
      </div>
    );
  }
}

export default withRouter(EstablishmentRequestCard);
